/**
 * Manifest fetching utilities. Cache-busted GET against
 * `/manifest-version.json`, with a generic `withTimeout` helper used by the
 * cleanup pipeline.
 */

import type { ManifestPayload } from "./types";

export async function withTimeout<T>(
  p: Promise<T>,
  ms: number,
  label: string
): Promise<T | null> {
  return Promise.race<T | null>([
    p.catch((e) => {
      console.warn(`[VersionWatcher] step "${label}" failed:`, e);
      return null;
    }),
    new Promise<null>((resolve) => setTimeout(() => resolve(null), ms)),
  ]);
}

export async function fetchManifest(
  signal?: AbortSignal
): Promise<{ manifest: ManifestPayload; url: string }> {
  const url = `/manifest-version.json?t=${Date.now()}&r=${Math.random().toString(36).slice(2, 8)}`;
  const res = await fetch(url, {
    cache: "no-store",
    credentials: "omit",
    signal,
    headers: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
    },
  });
  if (!res.ok) throw new Error(`manifest_http_${res.status}`);
  const data = await res.json();
  return {
    url,
    manifest: {
      version: typeof data?.version === "string" ? data.version : null,
      minVersion: typeof data?.minVersion === "string" ? data.minVersion : null,
      forceRefresh: data?.forceRefresh === true,
      timestamp: typeof data?.timestamp === "string" ? data.timestamp : null,
    },
  };
}
